import { EventValue, EventProperties } from 'core/analytics/entities';
import { AmplitudeService, AnalyticsService } from 'core/analytics/interfaces';

export class AnalyticsServerService implements AnalyticsService {
  constructor(private readonly amplitudeService: AmplitudeService) {}

  trackEvent(event: EventValue, properties?: EventProperties) {
    this.amplitudeService.trackEvent(event, properties);
  }

  setUserExperimentGroupName(experimentName: string, groupName: string) {
    this.amplitudeService.setUserExperimentGroupName(experimentName, groupName);
  }

  getAttributionParameters() {
    return {
      fbp: '',
      fbc: '',
    };
  }

  getDeviceId() {
    return '';
  }

  getSessionId() {
    return '';
  }

  funnelOpened() {
    return null;
  }

  flowOpened() {
    return null;
  }
  trackUserLanguage() {
    return null;
  }

  updateUserProperties() {
    return null;
  }

  setUserAge() {
    return null;
  }

  optOtSellUserData() {
    return null;
  }

  setUserId() {
    return null;
  }

  addUserAssociatedId() {
    return null;
  }

  setIsUserTester() {
    return null;
  }

  paymentPlanChosen() {
    return null;
  }

  paymentFormOpened() {
    return null;
  }

  policyPageOpened() {
    return null;
  }

  faqPageOpened() {
    return null;
  }

  contactUsPageOpened() {
    return null;
  }

  launch() {
    return null;
  }

  paymentClick() {
    return null;
  }

  paymentCardChosen() {
    return null;
  }

  paymentPaypalChosen() {
    return null;
  }

  paymentRetried() {
    return null;
  }

  paymentError() {
    return null;
  }

  async paymentSuccess() {
    return null;
  }

  emailUpsellScreenOpen() {
    return null;
  }

  addToCart() {
    return null;
  }

  initiateCheckout() {
    return null;
  }

  addEmail() {
    return null;
  }

  purchaseSucceed() {
    return null;
  }

  purchaseError() {
    return null;
  }

  upsellPremiumScreenOpened() {
    return null;
  }

  consultationUpsellScreenOpened() {
    return null;
  }

  readingsPackUpsellScreenOpened() {
    return null;
  }

  consultationUpsellWithDiscountScreenOpened() {
    return null;
  }

  readingsPackUpsellWithDiscountScreenOpened() {
    return null;
  }

  upsellPremiumScreenClicked() {
    return null;
  }

  upsellPremiumScreenGetReport() {
    return null;
  }

  phoneNumberScreenOpen() {
    return null;
  }

  phoneNumberScreenAdd() {
    return null;
  }

  phoneNumberScreenSkip() {
    return null;
  }

  lead() {
    return null;
  }

  natalChartUpsellGetReport() {
    return null;
  }

  addUserId() {
    return null;
  }

  setFeatureFlagsAttributes() {
    return null;
  }
}
